import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  inputLabel: {
    height: "1rem",
    transform: "translate(0, -1.5px) scale(0.75)",
  },
}));



// WEBPACK FOOTER //
// ./src/features/director/pages/dashboard/components/advanced-filters/styles.ts